import {EmailFilterModel, GetMessageModel, SetWaMessageModel, SpecialFolder, SuperBit_swaggerClient} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class WhatsAppModel {
    client:any;
    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }

    async whatsappIndex(filter?: any) {
        return await this.client.whatsappIndex(filter);
    }

    async whatsAppSendMessage(data: any) {
        return this.client.whatsappSendMessage(data);
    }
    async whatsappSendMessageInner(data: any) {
        return this.client.whatsappSendMessageInner(data);
    }

    async customerCardGetUsers() {
        return this.client.customerCardGetUsers();
    }

    async whatsappSolidStar(dataObject: any) {
        return this.client.whatsappAddStar(dataObject);
    }

    async whatsappLightStar (dataObject: any) {
        return this.client.whatsappRemoveStar(dataObject);
    }

    async WhatsappGetNewMessages () {
        return this.client.WhatsappGetNewMessages();
    }

    async whatsappSearchMessage (searchText: string | undefined, fromDate: string | undefined, toDate: string | undefined, type='all') {
        return this.client.whatsappSearchMessage(searchText, fromDate, toDate, type);
    }

    async whatsappGetMessage(dataObject: any) {
        return this.client.whatsappGetMessage(dataObject);
    }

    async whatsappTransfer(body: any) {
        return this.client.whatsappTransfer(body);
    }

    async whatsappSendFollowUpMessage(dataObject: any) {
        return this.client.whatsappSendFollowUpMessage(dataObject);
    }

    async whatsappGetIdByPhone(phone: string) {
        return this.client.whatsappGetIdByPhone(phone);
    }
}